import { fetchSingleChildBundleData } from "../../../api/OrdersApi";

const getChildBundleDataFromApi = async (checkPairedBundles: any[]) => {
	const filteredNonChildBundles = checkPairedBundles.filter(
		(bundle) =>
			!bundle.childBundle ||
			!Array.isArray(bundle.childBundle) ||
			bundle.childBundle.length === 0,
	);
	const filteredChildBundles = checkPairedBundles.filter(
		(bundle) =>
			bundle.childBundle &&
			Array.isArray(bundle.childBundle) &&
			bundle.childBundle.length > 0,
	);

	const results = await Promise.all(
		filteredChildBundles.map(async (bundle) => {
			// Await all child bundle promises for this parent bundle
			const formattedChildBundles = await Promise.all(
				bundle.childBundle.map(async (childBundle: any) => {
					const fetchedBundleData = await fetchSingleChildBundleData(
						childBundle.bundle.uuid,
					);

					const bundleLeasePrice =
						fetchedBundleData._bundleLeasePrice;
					const bundleUnitPrice = fetchedBundleData._bundleUnitPrice;

					const formattedBundleItems = childBundle.bundleItems.map(
						(salesOrderBundleItem: any) => {
							const fetchedChildBundleItem =
								fetchedBundleData.bundleItems.find(
									(fetchedBundleItem: any) =>
										fetchedBundleItem.item.uuid ===
										salesOrderBundleItem.item.uuid,
								);

							return {
								...salesOrderBundleItem,
								bundle: {
									...salesOrderBundleItem.bundle,
								},
								originalBundleItemGroup:
									fetchedChildBundleItem?.bundleItemGroup,
							};
						},
					);

					return {
						...childBundle,
						_bundleLeasePrice: bundleLeasePrice,
						_bundleUnitPrice: bundleUnitPrice,
						bundleItems: formattedBundleItems,
					};
				}),
			);

			// Return the parent bundle with updated childBundle array
			return {
				...bundle,
				childBundle: formattedChildBundles,
			};
		}),
	);

	return [...filteredNonChildBundles, ...results];
};

export default getChildBundleDataFromApi;
